import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "This study requires a fullscreen view", "Screenout", "User failed mobile fullscreen check", "app.error.fullscreen")